<div class="address-form" [formGroup]="addressForm">
  <div *ngIf="!editingUserAccount" class="option">
    <div>
      <h2>{{ (addressType === 'postal' ? 'address_capitalized_postal' : 'address_capitalized_physical') | translate }}</h2>
    </div>
    <button mat-raised-button color="primary" type="button" (click)="copyAddress()">
      <mat-icon>copy_all</mat-icon>
      {{ (addressType === 'postal' ? 'use_my_postal' : 'use_my_physical') | translate }}
    </button>
  </div>
  <div *ngIf="alternativeAddress" class="alternative-option">
    <button mat-raised-button color="primary" type="button" (click)="copyAddress()">
      <mat-icon>copy_all</mat-icon>
      {{ 'use_my_' + (alternativeAddress?.type || 'physical') + '_on_' + addressType | translate }}
    </button>
  </div>
  <form formGroupName="address" (submit)="onSubmit()">
    <div>
      <mat-form-field>
        <mat-label>{{ 'line1' | translate }}</mat-label>
        <input
          matInput
          type="text"
          placeholder="{{ 'search_' + (editingUserAccount ? 'the' : 'my') + '_address_' + addressType | translate }}"
          formControlName="location"
          #locationInput
          formControlName="line1"
          [matAutocomplete]="autoAddress"
          (keyup)="populateAddressFields($event)"
        />
        <mat-autocomplete #autoAddress="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
          @for (option of addressSuggestions; track option) {
            <mat-option [value]="option">
              {{ option.placePrediction?.text?.text }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <gc-input-field statusIcon [error]="true" formControlName="line2" label="{{ 'line_2' | translate }}"></gc-input-field>
      <gc-input-field statusIcon [error]="true" formControlName="suburb" label="{{ 'suburb' | translate }}"></gc-input-field>
      <gc-input-field
        statusIcon
        errorMap="{{ 'required_field_please_fill_it_in' | translate }}"
        [error]="true"
        formControlName="city"
        label="{{ 'city' | translate }} *"
      ></gc-input-field>
      <gc-input-field
        statusIcon
        [errorMap]="{
          required: 'required_field_please_fill_it_in' | translate,
          minlength: 'this_should_be_of_a_minimum_of_4_characters' | translate,
        }"
        [error]="true"
        formControlName="postcode"
        label="{{ 'postal_code_*' | translate }}"
      ></gc-input-field>
    </div>
    <div class="save-button" *ngIf="editingUserAccount">
      <button type="submit" mat-raised-button color="primary">
        <mat-icon svgIcon="content-save"></mat-icon>
        {{ 'save_address' | translate }}
      </button>
    </div>
  </form>
</div>
